import React from 'react';

const TestimonialBlock = ({ author, quote, job_title }) => (
  <div className="testimonial">
    <blockquote>{quote}</blockquote>
    <p>
      <strong>{author}</strong>
      {job_title && <span> – {job_title}</span>}
    </p>
  </div>
);

export default TestimonialBlock;
